"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerPlugin = void 0;

var router_1 = require("./router");

var utils_1 = require("./utils");

var builders_1 = require("./builders");

var memoryHistroy = {
  pushState: function pushState(state, _, url) {},
  replaceState: function replaceState(state, _, url) {}
};

function routerPlugin(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'router',
    events: {
      afterPlugin: function afterPlugin() {
        var _a, _b, _c, _d;

        (0, router_1.setRouterContext)({
          history: options.history || (typeof window !== 'undefined' ? window.history : memoryHistroy),
          location: options.location || (typeof window !== 'undefined' ? window.location : {
            pathname: '',
            search: '',
            hash: ''
          }),
          encodeParams: (_a = options.encodeParams) !== null && _a !== void 0 ? _a : utils_1.encodeParams,
          decodeParams: (_b = options.decodeParams) !== null && _b !== void 0 ? _b : utils_1.decodeParams,
          pathFromRoutesToWindow: function pathFromRoutesToWindow(path) {
            return path;
          },
          pathFromWindowToRoutes: function pathFromWindowToRoutes(path) {
            return path;
          },
          options: options,
          beforeUnloadInterceptors: new Set(),
          historyStateCount: typeof window !== 'undefined' && typeof ((_c = window.history.state) === null || _c === void 0 ? void 0 : _c.count) === 'number' ? (_d = window.history.state) === null || _d === void 0 ? void 0 : _d.count : null
        });
      },
      afterReduxStore: function afterReduxStore() {
        router_1.router.mount();
      },
      legacyBuild: function legacyBuild(logic, input) {
        'urlToAction' in input && input.urlToAction && (0, builders_1.urlToAction)(input.urlToAction)(logic);
        'actionToUrl' in input && input.actionToUrl && (0, builders_1.actionToUrl)(input.actionToUrl)(logic);
        'beforeUnload' in input && input.beforeUnload && (0, builders_1.beforeUnload)(input.beforeUnload)(logic);
      }
    }
  };
}

exports.routerPlugin = routerPlugin;